import React from 'react'
import PropTypes from 'prop-types'

import searchBoxIcon from 'resources/search_box_icon.png'

export default class SearchBox extends React.Component {

  static propTypes = {
    onValueChanged: PropTypes.func.isRequired,
    width: PropTypes.number,
    style: PropTypes.shape()
  }

  constructor(props) {
    super(props)
    this.state = {
      focused: false
    }
  }

  handleInputFocus = focused => {
    this.setState({
      focused
    })
  }

  render() {
    return (
      <div style={{ ...styles.searchBox(this.state.focused, this.props.width), ...this.props.style }}>
        <div style={styles.content}>
          <img src={searchBoxIcon} width={24} height={24} />
          <input
            style={styles.searchInput}
            onFocus={() => this.handleInputFocus(true)}
            onBlur={() => this.handleInputFocus(false)}
            type='text'
            onChange={event => this.props.onValueChanged(event.target.value)} />
        </div>
      </div>
    )
  }

}

const styles = {
  searchBox: (focused, width) => ({
    width: width || 300,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    border: focused ? 'solid 1px #359be0' : '1px solid #e2e2e2'
  }),
  content: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: 6
  },
  searchInput: {
    border: 'none',
    marginLeft: 4,
    outline: 0,
    height: 24,
    width: 275-32,
    fontSize: 14
  }
}



// WEBPACK FOOTER //
// ./src/billing/common/SearchBox.js